import type { CustomIconProps } from '../CustomIcon';

export const BugIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  size = 24,
  solid,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M17.344 17.719c1.354 1.102 2.156 2.16 2.156 4.031M6.656 17.719C5.302 18.82 4.5 19.878 4.5 21.75M18 9.75c1.354-1.102 1.5-2.628 1.5-4.5M6 9.656C4.646 8.554 4.5 7.122 4.5 5.25M21.75 13.506H18M6 13.506H2.25'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 21c-3.3 0-6-2.7-6-6v-4.503c0-3.05 2.7-4.5 6-4.5s6 1.2 6 4.5V15c0 3.3-2.7 6-6 6Z'
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 9v12'
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8.41 6.728a2.3 2.3 0 0 1-.16-.738 3.75 3.75 0 0 1 3.74-3.74h.02a3.75 3.75 0 0 1 3.74 3.74c-.01.23-.059.457-.146.67'
      fill={color}
    />
    <path
      d='M8.41 6.728a2.3 2.3 0 0 1-.16-.738 3.75 3.75 0 0 1 3.74-3.74h.02a3.75 3.75 0 0 1 3.74 3.74c-.01.23-.059.457-.146.67'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
